import React from 'react'
import styled from 'styled-components'
import { giphyDarkestGrey } from '@giphy/js-brand'

const DeleteModalContainer = styled.div<{ isOpen: boolean }>`
    width: 400px;
    background-color: ${giphyDarkestGrey};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
`

const Dim = styled.div`
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
`

interface Props {
    isOpen?: boolean
    className?: string
    onClickOutside?: () => void
}

const DeleteModal: React.FC<Props> = props => {
    if (props.isOpen) {
        return (
            <>
                <Dim onClick={() => (props.onClickOutside ? props.onClickOutside() : null)} />
                <DeleteModalContainer isOpen={props.isOpen} className={props.className}>
                    {props.children}
                </DeleteModalContainer>
            </>
        )
    } else {
        return null
    }
}

DeleteModal.defaultProps = {
    isOpen: true,
} as Partial<Props>

export default DeleteModal
